/**
 * Accreditation 1052 — KUK home accreditation strip.
 * Badge + label rows in `metadata`; three section colours.
 *
 * `divider_color` is not an `accreditations` column — it rides in the table's
 * `settings` JSON (see server/services/accreditations.js), which is how every
 * variant-specific section field on this table is stored.
 */

export const ACCREDITATION_1052_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Accreditation badges",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_image: "",
    meta_alt_image: "",
    meta_title: "",
    meta_priority: 1,
    meta_status: true,
  },

  ACCREDITATION_FIELDS_CONFIG: [
    {
      fieldName: "background_color",
      label: "Band background",
      value: "rgba(159, 28, 51, 0.2)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "rgba(159, 28, 51, 0.2)",
      description: "The reference is the brand maroon at 20%.",
      defaultValue: "rgba(159, 28, 51, 0.2)",
    },
    {
      fieldName: "title_text_color",
      label: "Badge label colour",
      value: "#031F44",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#031F44",
    },
    {
      fieldName: "divider_color",
      label: "Divider colour",
      value: "#9F1C3345",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "#9F1C3345",
      description: "The hairline between neighbouring badges.",
      defaultValue: "#9F1C3345",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Badge image",
      fieldName: "meta_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload accreditation badge",
      defaultValue: "",
    },
    {
      header: "Badge alt",
      fieldName: "meta_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Label",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "UGC Entitled",
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
